<template>
  <beer class="experimental" itemId="2000000008" itemName="sober-fox" title="Sober Fox, 9 °P, APA">
    <p
      style="
          margin: auto;
          text-align: justify;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      Zlatavá barva, vyšší hořkost a plné tělo. Vyšší stupeň prokvašení dává vyniknout potenciálu použitých amerických
      chmelů. Ve vůni můžeme najít tóny melounu, meruněk a citrusů.
    </p>

    <table
      class="tg"
      style="
          margin: auto;
          text-align: left;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      <tbody>
        <tr>
          <td class="bold">Pivní styl</td>
          <td class="right">American IPA</td>
        </tr>
        <tr>
          <td>Stupňovitost</td>
          <td class="right">9 °P</td>
        </tr>
        <tr>
          <td>Alkohol</td>
          <td class="right">3,9 %</td>
        </tr>
        <tr>
          <td>Barva</td>
          <td class="right">3,1 SRM</td>
        </tr>
        <tr>
          <td>Hořkost</td>
          <td class="right">31 IBU</td>
        </tr>
        <tr>
          <td>Slady</td>
          <td class="right">světlý, plzeňský, pšeničný</td>
        </tr>
        <tr>
          <td>Chmely</td>
          <td class="right">Amarillo, El Dorado, Nugget</td>
        </tr>
      </tbody>
    </table>
  </beer>
</template>

<script>
import Beer from "../Beer";
export default {
  name: "SoberFox",
  components: { Beer },
};
</script>   